<template>
  <div class="form p-2">
    <div class="row">
      <div class="col">
        <b-input-group class="mb-4">
          <b-input class="" id="name" placeholder="Guard" v-model="manpower_type.name"
            :class="[isSubmit ? (errorMsg.name ? 'is-invalid' : 'is-valid') : '']"></b-input>
        </b-input-group>
        <b-form-invalid-feedback :class="{ 'd-block mb-2': isSubmit && errorMsg.name }">
          {{ isSubmit && errorMsg.name ? errorMsg.name : '' }}
        </b-form-invalid-feedback>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="col text-center">
          <label class="switch s-icons s-outline s-outline-success" style="width:100%">
            <input type="checkbox" name="ismanager" v-model="manpower_type.isManager"
              :checked="manpower_type.isManager">
            <span class="slider" style="margin: 0 auto"></span>
          </label>
          <label class="ismanager-input" for="ismanager">Is Manager?</label>
        </div>
      </div>
    </div>
    <div class="row mt-4" v-if="manpower_type.id">
      <div class="col text-center">
        <b-button variant="primary" @click="updateManPowerType">Update</b-button>
      </div>
    </div>
    <div class="row mt-4" v-else>
      <div class="col text-center">
        <b-button variant="primary" @click="saveManPowerType">Save</b-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    initialManpowerType: {
      type: Object,
      required: false,
    },
    onSave: {
      type: Function,
      required: true,
    },
  },
  components: {

  },
  data() {
    return {
      manpower_type: this.initialManpowerType ? { ...this.initialManpowerType } : {
        id: null,
        name: null,
        isManager: false
      },
      sa: null,
      errorMsg: {},
      isSubmit: false
    };
  },
  mounted() {
    this.sa = this.$swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
  },
  watch: {
    initialManpowerType(newVal) {
      this.manpower_type = { ...newVal };
    }
  },
  methods: {
    validateFields() {
      let flag = false;
      if (!this.manpower_type.name) {
        flag = true;
        this.$set(this.errorMsg, 'name', 'Name is Required!');
      }
      if (!flag) {
        return true
      } else {
        return false
      }
    },
    resetFields() {
      this.manpower_type = {
        id: null,
        name: null,
        isManager: false
      }; // Create a local copy of the user object

      this.errorMsg = {};
      this.isSubmit = false
    },
    async saveManPowerType() {
      this.errorMsg = {};
      this.isSubmit = true;
      if (this.validateFields()) {
        try {
          await this.$store.dispatch('business/addManPowerType', this.manpower_type)
          const newManPowerType = this.$store.state.business.addedManPowerType
          this.sa.fire({
            icon: 'success',
            title: `Designation Successfully Added!`
          });
          this.onSave(newManPowerType); // Use the provided onSave handler
          this.resetFields();
        }
        catch (error) {
          console.log('error', error)
          this.sa.fire({
            icon: 'error',
            title: `${error}`
          });
        }

      } else {
        this.sa.fire({
          icon: 'error',
          title: `Check For Errors!`
        });
      }
    },

    async updateManPowerType() {
      this.errorMsg = {};
      this.isSubmit = true;
      if (this.validateFields()) {
        try {
          await this.$store.dispatch('business/updateManpowerType', this.manpower_type)
          const newManPowerType = this.$store.state.business.addedManPowerType
          this.sa.fire({
            icon: 'success',
            title: `Designation Successfully Updated!`
          });
          this.onSave(newManPowerType); // Use the provided onSave handler
          this.resetFields();
        }
        catch (error) {
          console.log('error', error)
          this.sa.fire({
            icon: 'error',
            title: `${error}`
          });
        }

      } else {
        this.sa.fire({
          icon: 'error',
          title: `Check For Errors!`
        });
      }
    },
  },
};
</script>